import React, { useEffect, useRef, useState } from 'react'
import Slider from 'react-slick'
import Image from 'next/image'

const TechnologiesStackSection = () => {
  const [processSlider, setProcessSlider] = useState<Slider | null>(null)
  const [processSliderNav, setProcessSliderNav] = useState<Slider | null>(null)

  const processSettings = {
    dots: false,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 5000,
    speed: 1000,
    adaptiveHeight: true,
    pauseOnHover: true,
    infinite: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  }
  const processNavSettings = {
    slidesToShow: 7,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    variableWidth: true,
    infinite: true,
    speed: 1000,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          infinite: true,
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  }

  const sliderRef = useRef<any>(null)
  useEffect(() => {
    const sliderElement = sliderRef.current

    // Calculate the section's position on the screen
    const section = document.getElementById(
      'your-section-id'
    ) as HTMLElement | null
    if (section) {
      const sectionTop = section.offsetTop
      const sectionHeight = section.offsetHeight
      const sectionBottom = sectionTop + sectionHeight

      // Check if the section is in the viewport
      const handleScroll = () => {
        const viewportTop = window.scrollY
        const viewportBottom = viewportTop + window.innerHeight

        if (viewportTop <= sectionBottom && viewportBottom >= sectionTop) {
          sliderElement.slickPlay()
        } else {
          sliderElement.slickGoTo(0)
          sliderElement.slickPause()
        }
      }

      window.addEventListener('scroll', handleScroll)
      return () => {
        window.removeEventListener('scroll', handleScroll)
      }
    }

    return undefined // Return undefined if section is not found
  }, [])

  return (
    <section className="process_section section_space">
      <div className="container" id="your-section-id">
        <div className="section_titles">
          <p className="sub_title">Our Process</p>
          <h2 className="title">
            From Vision to Reality: Our eCommerce Solution Development Approach
          </h2>
        </div>
        <ul className="nav nav-tabs">
          <Slider
            {...processNavSettings}
            className="process_carousel_nav"
            swipeToSlide
            focusOnSelect
            ref={setProcessSliderNav}
            asNavFor={sliderRef.current || undefined}
          >
            <li className="nav-item">
              <div className="nav-link">Ideation and Planning</div>
            </li>
            <li className="nav-item">
              <div className="nav-link">Setup and Configuration</div>
            </li>
            <li className="nav-item">
              <div className="nav-link">Theme Design</div>
            </li>
            <li className="nav-item">
              <div className="nav-link">Development</div>
            </li>
            <li className="nav-item">
              <div className="nav-link">Testing</div>
            </li>
            <li className="nav-item">
              <div className="nav-link">Release</div>
            </li>
            <li className="nav-item">
              <div className="nav-link">Ongoing Support</div>
            </li>
          </Slider>
        </ul>
        <div className="tab-content " id="myTabContent">
          <Slider
            {...processSettings}
            className="process_carousel"
            ref={sliderRef}
            asNavFor={processSliderNav || undefined}
          >
            <div className="" id="tab1">
              <div className="row">
                <div className="col-md-7">
                  <div className="left_content">
                    <div className="title">Ideation and Planning</div>
                    <p>
                      We collaborate with you to understand your goals and
                      envision a tailored ecommerce solution that aligns with
                      your objectives, target audience, and business
                      requirements.
                    </p>
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="right_content">
                  <Image
                 width={510}
                    height={467}
                      className="img-fluid"
                      src="/assets/images/ecommerce-development-company/process/ideation.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="" id="tab2">
              <div className="row">
                <div className="col-md-7">
                  <div className="left_content">
                    <div className="title">Setup and Configuration</div>
                    <p>
                      Our experts set up a robust infrastructure, configure the
                      necessary platforms and tools, and optimize the
                      environment for seamless ecommerce operations.
                    </p>
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="right_content">
                  <Image
                 width={646}
                    height={467}
                      className="img-fluid"
                      src="/assets/images/ecommerce-development-company/process/setup.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="" id="tab3">
              <div className="row">
                <div className="col-md-7">
                  <div className="left_content">
                    <div className="title">Theme Design</div>
                    <p>
                      We create visually stunning and user-friendly themes that
                      reflect your brand identity and provide an engaging
                      shopping experience for your customers.
                    </p>
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="right_content">
                  <Image
                 width={646}
                    height={467}
                      className="img-fluid"
                      src="/assets/images/ecommerce-development-company/process/theme-design.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="" id="tab4">
              <div className="row">
                <div className="col-md-7">
                  <div className="left_content">
                    <div className="title">Development</div>
                    <p>
                      Our skilled developers leverage cutting-edge technologies
                      and coding practices to build a scalable and feature-rich
                      ecommerce solution tailored to your unique needs.
                    </p>
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="right_content">
                  <Image
                 width={646}
                    height={467}
                      className="img-fluid"
                      src="/assets/images/ecommerce-development-company/process/development.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="" id="tab5">
              <div className="row">
                <div className="col-md-7">
                  <div className="left_content">
                    <div className="title">Testing</div>
                    <p>
                      We conduct rigorous testing to ensure that your ecommerce
                      solution functions flawlessly, offering a smooth browsing
                      experience, secure transactions, and reliable performance.
                    </p>
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="right_content">
                  <Image
                 width={646}
                    height={467}
                      className="img-fluid"
                      src="/assets/images/ecommerce-development-company/process/testing.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="" id="tab6">
              <div className="row">
                <div className="col-md-7">
                  <div className="left_content">
                    <div className="title">Release</div>
                    <p>
                      Once thoroughly tested, we deploy your ecommerce solution,
                      ensuring a seamless transition from development to the
                      live environment.
                    </p>
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="right_content">
                  <Image
                 width={646}
                    height={467}
                      className="img-fluid"
                      src="/assets/images/ecommerce-development-company/process/release.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="" id="tab7">
              <div className="row">
                <div className="col-md-7">
                  <div className="left_content">
                    <div className="title">Ongoing Support</div>
                    <p>
                      Our team provides continuous support, maintenance, and
                      updates to keep your ecommerce solution running smoothly,
                      addressing any issues promptly and optimizing its
                      performance over time.
                    </p>
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="right_content">
                  <Image
                 width={646}
                    height={467}
                      className="img-fluid"
                      src="/assets/images/ecommerce-development-company/process/support.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </Slider>
        </div>
      </div>
    </section>
  )
}

export default TechnologiesStackSection
